import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {TaskModel} from "../../../tasks/models/task.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {LocationType} from "../../../commons/types/location.type";
import {TaskStatusType} from "../../../tasks/types/taskStatus.type";
import {TaskType} from "../../../tasks/types/task.type";

export class AgentTasksViewComponent implements IController {

  agent: AgentModel;
  tasks: TaskModel[];
  date: any;
  isAllowDatepicker: boolean = false;
  isAllowMap: boolean = true;
  onChangeTaskStatus: Function;
  onDateChange: Function;
  isExpandRelations: boolean = false;

  public configZoneId: string;
  public locationTypes: typeof LocationType = LocationType;
  public taskType: typeof TaskType = TaskType;
  public highlightedTaskId: string;
  public expandedRelationsMap: any;
  public isMapEnabled: boolean = false;
  public maximumDate: any;

  constructor(private splitService: SplitService, private moment) {
  }

  $onInit() {
    this.expandedRelationsMap = {};
    this.configZoneId = this.splitService.getTimeZone();
    this.maximumDate = this.moment().valueOf();

    if (this.isExpandRelations) {
      this.tasks.forEach(task => {
        this.expandedRelationsMap[task.id] = true;
      })
    }
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.tasks && !changes.tasks.isFirstChange() && this.isExpandRelations) {
      this.tasks.forEach(task => {
        this.expandedRelationsMap[task.id] = true;
      })
    }
  }

  onHighlightedChanged(serviceId, taskId) {
    this.highlightedTaskId = taskId;
  }

  sliceId(id) {
    return id.slice(-4);
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentTasksView', {
    bindings: {
      agent: '<',
      tasks: '<',
      date: '<?',
      isAllowDatepicker: '<?',
      isAllowMap: '<?',
      isExpandRelations: '<?',
      onChangeTaskStatus: '&',
      onDateChange: '&'
    },
    template: require('./agent-tasks-view.html').default,
    controller: AgentTasksViewComponent
  });
